export const SLOT_QUERY_KEYS = {
  GET_SLOT: 'GET_SLOT',
  GET_SLOT_BOX_LIST: 'GET_SLOT_BOX_LIST',
  GET_SLOT_DATE_LIST: 'GET_SLOT_DATE_LIST',
} as const;
